import React, { useState } from 'react';
import { Card, Tabs, Badge } from 'antd';
import type { TabsProps } from 'antd';
import {
  NodeIndexOutlined,
  BookOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import EntityExplorer from './components/EntityExplorer';
import SmartRegulation from './components/SmartRegulation';
import RiskMonitor from './components/RiskMonitor';
import './index.css';

const KnowledgeGraph: React.FC = () => {
  const [activeTab, setActiveTab] = useState('entity');

  const items: TabsProps['items'] = [
    {
      key: 'entity',
      label: (
        <span className="flex items-center gap-2">
          <NodeIndexOutlined />
          实体关系探索
          <Badge count="核心" style={{ backgroundColor: '#1890ff', fontSize: 10 }} />
        </span>
      ),
      children: <EntityExplorer />,
    },
    {
      key: 'regulation',
      label: (
        <span className="flex items-center gap-2">
          <BookOutlined />
          智能法规推荐
          <Badge count="AI" style={{ backgroundColor: '#52c41a', fontSize: 10 }} />
        </span>
      ),
      children: <SmartRegulation />,
    },
    {
      key: 'risk',
      label: (
        <span className="flex items-center gap-2">
          <WarningOutlined />
          风险预警看板
          <Badge count="监控" style={{ backgroundColor: '#faad14', fontSize: 10 }} />
        </span>
      ),
      children: <RiskMonitor />,
    },
  ];

  return (
    <div className="p-6 h-[calc(100vh-112px)] flex flex-col bg-gray-100">
      <h1 className="text-2xl font-bold mb-4">知识图谱</h1>

      <Card className="flex-1 shadow-sm overflow-hidden" styles={{ body: { height: '100%', padding: 0 } }}>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          className="knowledge-graph-tabs h-full"
          tabBarStyle={{ margin: 0, padding: '12px 12px 0', background: '#fafafa' }}
          items={items}
        />
      </Card>
    </div>
  );
};

export default KnowledgeGraph;
